export function getJwtClaim(token: string, claim: string): string | undefined {
    const parts = token.split('.')
    if (parts.length < 2) {
        return undefined
    }
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        const payload = JSON.parse(atob(base64)) as Record<string, unknown>
        const value = payload[claim]
        if (value === undefined || value === null) {
            return undefined
        }
        return String(value)
    } catch {
        return undefined
    }
}
